<template>
	<div>
		<head-nav></head-nav>
		<div>
			<div class="clearfix">
				<div class="shopping-button  float-right">
					<button class="btn btn-dark" style="color:#fff;font-family:'belerno';" @click="toLoggin">
						Login
					</button>
					&nbsp;
					<button class="btn btn-dark">
						<router-link style="color:#fff !important;;font-family:'belerno';" to="/cart" exact><i
								class="el-icon-shopping-bag-1"></i> ({{ library.length }}) View
							Cart</router-link>
					</button>
				</div>
			</div>
			<div class="container-kiosk">
				<div class="container-grid">
					<div class="cards" v-for="issue in coverArray">
						<div class="image6">
							<img class="img-content" :src="issue.cover" :alt="issue.alt" />
							<img :src="issue.blurb" :alt="issue.alt" class="img-text" />
						</div>
						<div class="mt-2">
							<div>
								<button @click.stop="addTo(issue.issue)" class="btn btn-dark">Buy</button>
							</div>
							<div class="mt-2">
								<h6 class="card-title">{{ issue.name }}</h6>
							</div>
							<div class="mb-2" style="font-family:berleno">
								Price: ${{ issue.price }}
							</div>
						</div>
					</div>
				</div>
			</div>

			<info></info>
		</div>
		<foot-miss></foot-miss>
	</div>
</template>

<script>
import { mapActions, mapState, mapMutations } from "vuex";
import covers from "../assets/covers.json"
import headNav from "./navBar";
import info from "./info";
import footMiss from "./footer";
import swal from 'sweetalert';
import Swal from 'sweetalert2';
export default {
	name: "kiosko",
	components: {
		headNav,
		info,
		footMiss
	},
	data() {
		return {
			token: "",
			logged: false,
			coverArray: []
		};
	},
	created() {
		this.coverArray = covers
		this.token = localStorage.getItem("token");
		this.logged = localStorage.getItem("logged");

	},

	methods: {
		toLoggin() {
			this.$router.push("/login");
		},
		...mapMutations("cart", ["addLibrary"]),
		addTo(issue) {
			this.addLibrary(issue);
			Swal.fire({
				title: "Great!",
				icon: "success",
				text: `${issue.name} was just added to your cart`,
				showConfirmButton: false,  
				timer: 3000,  
				timerProgressBar: true
			})
		},
	},
	computed: {
		...mapState("cart", ["library", "issue1", "issue2", "issue3", "issue4", "issue5", "issue6", "issue7", "issue8", "issue9", "issue10", "issue11","issue12"]),
	},
};
</script>

<style lang="scss">
.container-kiosk {
	max-width: 1535px;
	margin: auto;
}

.home-text {
	color: black;
	font-family: 'lemon_milkregular';
	font-style: italic;
	-webkit-font-smoothing: antialiased;
	font-size: 0.9em;
}

.shopping-button {
	font-family: 'lemon_milkregular';
	margin: 1rem 2rem;
}

.container-grid {
	display: grid;
	grid-template-columns: 1fr 1fr 1fr;
}

@media (max-width: 768px) {
	.container-grid {
		display: grid;
		grid-template-columns: 1fr 1fr;
	}
}

@media (max-width: 425px) {
	.container-grid {
		display: grid;
		grid-template-columns: 1fr;
	}
}

.cards {
	font-family: 'lemon_milkregular';
	padding: 1.5rem;
}

.image6 {
	position: relative;

	.img-content {
		width: 100%;
	}

	.img-text {
		display: none;
		width: 100%;
		position: absolute;
		cursor: context-menu;
	}

	&:hover .img-text {
		display: block;
		position: absolute;
		bottom: 0;
	}

}
</style>
